export default function getOrdersByStore(storeId, orders = []) {
  if (storeId === null || storeId === undefined) return []
  return orders.filter(order => order.storeId === storeId)
}
